module.exports = __webpack_public_path__ + "static/media/asahi-mizuno.0f5e8476.jpg";